import { useMemo } from "react";

// Simple deterministic strength scorer (0-4)
export function scorePassword(pw = "") {
  let score = 0;
  if (!pw) return { score: 0, label: "Too short", pct: 0, color: "#E2E8F0" };
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  score = Math.min(score, 4);
  const labels = ["Very weak", "Weak", "Fair", "Strong", "Excellent"];
  const colors = ["#D9534F", "#E6A700", "#FFB547", "#4070BC", "#2E8B57"];
  return { score, label: labels[score], pct: (score / 4) * 100, color: colors[score] };
}

export default function PasswordStrength({ password }) {
  const { label, pct, color } = useMemo(() => scorePassword(password), [password]);
  const suggestions = [];
  if (!password || password.length < 8) suggestions.push("At least 8 characters");
  if (password && password.length < 12) suggestions.push("12+ chars is stronger");
  if (password && !(/[a-z]/.test(password) && /[A-Z]/.test(password))) suggestions.push("Mix upper & lower case");
  if (password && !/\d/.test(password)) suggestions.push("Add a number");
  if (password && !/[^A-Za-z0-9]/.test(password)) suggestions.push("Add a symbol (!@#$)");
  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="h-2 w-full rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full transition-all duration-300" style={{ width: `${pct}%`, background: color }} />
      </div>
      <div className="flex items-center justify-between mt-1.5 text-xs">
        <span className="font-semibold" style={{ color }} data-testid="password-strength-label">{label}</span>
        {suggestions.length > 0 && <span className="text-slate-500">{suggestions[0]}</span>}
      </div>
    </div>
  );
}
